// rendom_code.js
const generatedStrings = new Set();

export function Randomcode(length) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let result;

  do {
    result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
  } while (generatedStrings.has(result));

  generatedStrings.add(result);
  return result;
}
